import React, { useEffect } from "react";
import { Table, Button, Popconfirm, Typography } from "antd";
import { PlusOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { fetchBomList, fetchBomByItem, deleteBom } from "../bomThunk";
import { resetBomForm } from "../bomSlice";

const { Title } = Typography;

const BOMList = ({ onEdit, onCreate }) => {
  const dispatch = useDispatch();
  const { bomList } = useSelector((s) => s.bom);

  useEffect(() => {
    dispatch(fetchBomList());
  }, [dispatch]);

  const columns = [
    {
      title: "Finished Product",
      dataIndex: "item_name",
    },
    {
      title: "Item Code",
      dataIndex: "item_code",
    },
    {
      title: "Total Material Cost",
      dataIndex: "total_material_cost",
      render: (v) => Number(v || 0).toFixed(2),
    },
    {
      title: "Action",
      render: (_, record) => (
        <>
          <Button
            icon={<EditOutlined />}
            size="small"
            style={{ marginRight: 8 }}
            onClick={() => {
              dispatch(fetchBomByItem(record.item_id));
              onEdit();
            }}
          />
          <Popconfirm
            title="Delete this recipe?"
            onConfirm={() => {
              dispatch(deleteBom(record.bom_id)).then(() => {
                dispatch(fetchBomList());
              });
            }}
          >
            <Button icon={<DeleteOutlined />} size="small" danger />
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>
          Bill of Materials
        </Title>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => {
            dispatch(resetBomForm());
            onCreate();
          }}
        >
          Create BOM
        </Button>
      </div>
      <Table
        dataSource={bomList}
        columns={columns}
        rowKey="bom_id"
        pagination={false}
      />
    </div>
  );
};

export default BOMList;
